export const environment = {
  production: true,
  api_url : 'https://3j8p065cgi.execute-api.eu-west-3.amazonaws.com/prd/',
  env_prefix : 'PD'
};
